export enum AtomTextSizeEnum {
  XLG = "xlg",
  LG = "lg",
  MD = "md",
  NR = "nr",
  SM = "sm",
  XS = "xs",
  XXS = "xxs",
}
